import React, { useContext, useEffect, useState } from "react";
import { useCustomerFeedback } from "./store";
import { createSortHandler } from "modules/utilities/utility";
import CustomerTable from "modules/customer_feedback/CustomerTable";
import PaginationDiv from "modules/pagination/PaginationDiv";
import BuildPlan from "./BuildPlan";
import { FeedbackDate } from "./FeedbackTab";

function BuildPlanComponent() {
  const {
    fetchCustomerFeedback,
    customerFeedbackData,
    isCustomerFeedbackLoading,
  } = useCustomerFeedback();
  const [sortData, setSortedData] = useState();
  const [filterData, setFilter] = useState([]);
  const [page, newPage] = useState(1);
  const [opa, setOpa] = useState("");
  const [count, setCount] = useState(0);
  const [pageCount, setPageCount] = useState(1);
  const { startDate, endDate } = useContext(FeedbackDate);
  const [plan, setPlan] = useState({
    happy_rate_1: 0,
    happy_rate_2: 0,
    happy_rate_3: 0,
    happy_rate_4: 0,
    happy_rate_5: 0,
  });

  useEffect(() => {
    if (customerFeedbackData.length) setSortedData(customerFeedbackData);
  }, [customerFeedbackData]);

  useEffect(() => {
    const numOfSubarrays = Math.max(Math.ceil((sortData?.length || 0) / 10), 0);
    const arrayOfArrays = sortData
      ? Array.from({ length: numOfSubarrays }, (_, i) => {
          const start = i * 10;
          const end = start + 10;
          return sortData?.slice(start, end);
        })
      : [];
    setPageCount(Math.max(Math.ceil((sortData?.length || 0) / 10), 1));
    setFilter(arrayOfArrays[page - 1]);
  }, [sortData, page]);

  useEffect(() => {
    let planObj = {
      happy_rate_1: 0,
      happy_rate_2: 0,
      happy_rate_3: 0,
      happy_rate_4: 0,
      happy_rate_5: 0,
    };
    if (Array.isArray(sortData)) {
      const updatedPlan = sortData.reduce(
        (prev, curr) => {
          if (curr?.happy_with_traya >= 1 && curr?.happy_with_traya <= 5) {
            const ratingKey = `happy_rate_${curr?.happy_with_traya}`;
            prev[ratingKey] += 1;
          }
          return prev;
        },
        { ...planObj }
      );
      setPlan(() => updatedPlan);
    }
  }, [sortData]);

  useEffect(() => {
    fetchCustomerFeedback(startDate.toISOString(), endDate.toISOString());
  }, [startDate]);

  const handleSortUpdatedDate = () =>
    createSortHandler(
      "updatedAt",
      count,
      setCount,
      setSortedData,
      setOpa,
      customerFeedbackData || []
    );

  return (
    <div className="d-flex flex-column gap-1 ">
      <div className="flex-1">
        <BuildPlan data={plan} planLength={sortData?.length} />
      </div>
      <div className="mt-2 flex-fill card p-2">
        <div className="mt-n2">
          <CustomerTable
            data={filterData}
            isLoading={isCustomerFeedbackLoading}
            error={"error"}
            opa={opa}
            handleSortUpdatedDate={handleSortUpdatedDate}
            isAction={true}
          />
          <PaginationDiv
            paginationData={{ pageCount: pageCount || 1, page: page }}
            newPage={newPage}
          />
        </div>
      </div>
    </div>
  );
}

export default BuildPlanComponent;
